// extracted by mini-css-extract-plugin
module.exports = {"container":"help-contacts_container__QpPTs","logo":"help-contacts_logo__13msy"};